module.exports = __webpack_public_path__ + "img/import.3d912c08.svg";